import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#448aff",
    },
    secondary: {
      main: "#f57c00",
    },
  },
});

export default theme;